var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide container"},[_c('h2',[_vm._v("Visualisierung")]),_c('PvInformation'),_c('DailyGraph',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }